import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrimeNGModule } from '../../primeng.module';
import { ToastService } from '../../services/toast/toast.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { LoginCustomerComponent } from '../login-customer/login-customer.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [BreadcrumbComponent, LoginCustomerComponent, PrimeNGModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  constructor(
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService
  ) {}

  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      const rawMessage = params['message'];
      const rawSuccess = params['success'] === 'true' ? true : false;
      const message = rawMessage ? decodeURIComponent(rawMessage) : null;
      if (message) {
        rawSuccess
          ? this.toastService.success(message, 5000)
          : this.toastService.error(message, 5000);
      }
    });
  }
}
